import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/8ff32d80-98b8-46ca-9cc9-3d2e9357b27e";
export const REGISTER_URL = "https://a.ntrk2.com/e51fb9fd-20dd-452f-a9f4-566b5b0cb7b7";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://gowinbd.loadprkw2a.com/download?openExternalBrowser=1&id=dyuowiumr0e6jgk";

export * from "./codes";
export * from "./context";
